export default __webpack_public_path__ + "static/howItWorksCard3-75ef5b0e486562bc65cecfeef8aee577.png";